import { comluxgroup } from '@luxuryescapes/contract-data-event-schemas'
import sanitizeItemContextMetadata from './sanitizeItemContextMetadata'
import getMerchandiseById from 'api/merchandise/getMerchandiseById'

async function getMerchandiseShippingItems(
  state: App.State,
  order: App.Order,
  isMultiCart?: boolean,
) {
  const itemPromises = order.merchandiseShippingItems.map(async orderItem => {
    const orderMerchandiseItem = order.merchandiseItems.find(
      item => item.shippingGroupId === orderItem.shippingGroupId,
    )

    if (!orderMerchandiseItem) {
      return comluxgroup.createItem_1_1_2({
        offerId: 'Shipping',
        categoryId: 'shop',
        productId: 'merchandise_shipping',
        price: orderItem.total,
        currency: order.currencyCode,
        itemId: orderItem.id,
        orderId: order.id,
        metadata: sanitizeItemContextMetadata({ isMultiCart }),
      })
    }

    const variantId = orderMerchandiseItem.variantId
    const stateOffer = state.merchandise.merchandise[orderMerchandiseItem.offerId ?? ''] as App.MerchandiseOffer | undefined
    const offer = stateOffer ?? await getMerchandiseById(orderMerchandiseItem.offerId)
    const variant = offer?.variants.find(v => v.id === variantId)

    return comluxgroup.createItem_1_1_2({
      offerId: variant?.shippingProfileId ?? 'Shipping',
      categoryId: 'shop',
      productId: 'merchandise_shipping',
      price: orderItem.total,
      currency: order.currencyCode,
      itemId: orderItem.id,
      orderId: order.id,
      metadata: sanitizeItemContextMetadata({ isMultiCart }),
    })
  })

  return Promise.all(itemPromises)
}

export default getMerchandiseShippingItems
